module.exports = __webpack_public_path__ + "img/disaster_relief-gallery-1.6c92f648.jpg";